import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';

import { AgreeServiceTermRequest } from 'src/app/core/dtos/dto';
import { HttpErrorResponseMessages } from 'src/app/core/dtos/http-error-response-messages';
import { AccountService } from 'src/app/core/services/account.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { StorageHelper } from 'src/app/core/services/helpers/storage.helper';

@Component({
  selector: 'app-service-term',
  templateUrl: './service-term.component.html',
  styleUrls: ['./service-term.component.scss']
})
export class ServiceTermComponent implements OnInit {
  userForm: FormGroup;
  serviceTermContent: string;
  personalInfoAgreement: '';
  serviceTermAgreement: '';
  privacyPolicyAgreement: '';
  ageAgreement: '';
  serviceTermId: number;
  regPoliciesUrl: string;

  get f() { return this.userForm.controls; }
  constructor(
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private router: Router,
    private storageHelper: StorageHelper,
    private toastService: HotToastService,
    private configHelper: ConfigHelper
  ) { }

  ngOnInit(): void {
    this.regPoliciesUrl = this.configHelper.getRegPoliciesUrl();
    this.userForm = this.formBuilder.group({
      personalInfoAgreement: [],
      serviceTermAgreement: [],
      privacyPolicyAgreement: [],
      ageAgreement: []
    });
    this.accountService.getActiveServiceTerm().subscribe(
      result => {
        //remove  inline styling from serviceTerm
        this.serviceTermContent = (result.content.content).replace(new RegExp('style="(.*?)"', 'g'), "");
        this.serviceTermId = result.content.id;
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }

  onSubmit() {
    const agreeServiceRequest: AgreeServiceTermRequest = {
      serviceTermId: this.serviceTermId
    };
    this.accountService.agreeServiceTerm(agreeServiceRequest).subscribe(
      () => {
        const upcomingTest = JSON.parse(this.storageHelper.loadFromSessionStorage("upcomingRegistration"));
        if (upcomingTest && upcomingTest?.biometricConsent !== true) {
          this.router.navigate(['account/biometric-consent']);
        }
        else {
          this.router.navigate(['my-account']);
        }
      },
      (error: HttpErrorResponse) => {
        if (error.status === 400) {
          const errorMessage = error.error as HttpErrorResponseMessages;
          errorMessage.reasons.forEach(reasons => {
            this.toastService.warning(reasons.errorMessage);
          });
        }
      });
  }
}
